import { WinFormsContentScreen } from '@winforms';
import { __asyncI18n } from '@localisation';
import { RoutingEntry } from '@routing';
import { RoutePrivilegeNames } from './routeprivilegenames';
import { DummySiteComponent } from '@site-info';
import {
     SystemApplicationSetNaviExtension,
     SystemEditComponent,
     SystemsListComponent,
     SystemUserListComponent,
     SystemUserEditComponent,
     SystemPlantsComponent,
     SystemNotificationListComponent,
     SystemNotificationSettingsComponent,
     SystemNotificationCreateFromTemplateComponent
} from '@systems';
import { CanActivateWithCurrentTenant } from '@plants';


export const SystemAdministrationRoutes: Array<RoutingEntry> = [
    {
        path: '',
        component: SystemsListComponent,
        data: {
            title: __asyncI18n('Systems', 'subnavi.administration.systems'),
            redirectTo: 'Administrations/Plants/:plantid/*firstChild',
            favouritesType: 'siteadministration'
        }
    },
    {
        path: 'Create',
        component: SystemEditComponent,
        data: {
            title: __asyncI18n('Create System', 'subnavi.administration.system.new'),
            testId: 'sidenavigation.system.new',
            dontShowInSubNavigation: true,
            dontShowFavourites: true,
            showParentInSubNavigation: true,
            showSubNaviLevel: 1
        },
    },
    {
        path: ':systemid',
        canActivate: [CanActivateWithCurrentTenant],
        data: {
            title: ':systemid | systemIdToName',
            showParentInSubNavigation: true,
            showChildrenAsSecondLevel: true,
            dontShowInSubNavigation: true,
            dontShowFavourites: true,
            favouritesRouteCaption: '[SystemName] / [PageName]',
            redirectTo: [
                'Administration/Systems/:systemid/Settings',
                'Administration/Systems/:systemid/Users',
                'Administration/Systems/:systemid/SystemNotifications',
                'Administration/Systems/:systemid/Plants'
            ],
        },
        children: [
            {
                path: '',
                component: DummySiteComponent,
                data: {
                    title: ':systemid | systemIdToName',
                    showParentInSubNavigation: true,
                    showChildrenAsSecondLevel: true,
                    dontShowInSubNavigation: true,
                    dontShowFavourites: true,
                    favouritesRouteCaption: '[SystemName] / [PageName]',
                    redirectTo: [
                        'Administration/Systems/:systemid/Settings',
                        'Administration/Systems/:systemid/Users'//,
                        //'Administration/Systems/:systemid/Alarms'
                    ]
                }
            },
            {
                path: 'Settings',
                data: {
                    title: __asyncI18n('System settings', 'subnavi.administration.system.settings'),
                    privileges: [
                        RoutePrivilegeNames.ManageSystemSettings,
                        RoutePrivilegeNames.ReadOnlySystemSettings
                    ],
                    testId: 'sidenavigation.system.settings',
                    dontShowFavourites: true
                },
                children: [
                    {
                        path: '',
                        component: SystemEditComponent,
                        data: {
                            title: __asyncI18n('System settings', 'subnavi.administration.system.settings'),
                            testId: 'sidenavigation.system.settings',
                            dontShowFavourites: true
                        }
                    },
                    {
                        path: 'ReplacingSite',
                        component: WinFormsContentScreen,
                        data: {
                            title: __asyncI18n('Replaceing system', 'subnavi.administration.system.replacing-site'),
                            contentRoute: '/Site/SiteAdministration/ReplacingSite/:plantid',
                            showParentInSubNavigation: true,
                            testId: 'sidenavigation.system.replace'
                        }
                    }
                ]
            },
            {
                path: 'Users',
                data: {
                    title: __asyncI18n('System users', 'subnavi.administration.system.plant.users'),
                    contentRoute: '/Site/SiteAdministration/Users/:plantid',
                    testId: 'sidenavigation.system.users',
                    dontShowFavourites: true,
                    privileges: [
                        RoutePrivilegeNames.ManageSystemUsers,
                        RoutePrivilegeNames.ReadOnlySystemUsers
                    ]
                },
                children: [
                    {
                        path: '',
                        component: SystemUserListComponent,
                        data: {
                            title: __asyncI18n('System users', 'subnavi.administration.system.plant.user.test'),
                            contentRoute: '/Site/SiteAdministration/Users/:plantid'
                        }
                    },
                    {
                        path: 'Add',
                        component: SystemUserEditComponent,
                        data: {
                            title: __asyncI18n('Add user', 'subnavi.administration.system.user.add'),
                            contentRoute: '/Site/SiteAdministration/SiteUser/:plantid',
                            testId: 'sidenavigation.system.users.add',
                            dontShowFavourites: true,
                            showParentInSubNavigation: true
                        }
                    },
                    {
                        path: ':userid',
                        component: SystemUserEditComponent,
                        data: {
                            title: ':userid | userIdToName',
                            contentRoute: '/Site/SiteAdministration/SiteUser/:plantid?userId=:userid',
                            testId: 'sidenavigation.system.user',
                            dontShowFavourites: true,
                            showParentInSubNavigation: true
                        }
                    }
                ]
            },
            // {
            //     path: 'Alarms',
            //     data: {
            //         title: __asyncI18n('Plant notifications', 'subnavi.administration.system.alarms'),
            //         contentRoute: '/Site/SiteAdministration/Alarms/:plantid',
            //         testId: 'sidenavigation.link.alarmnotifications'
            //     },
            //     children: [
            //         {
            //             path: '',
            //             component: WinFormsContentScreen,
            //             data: {
            //                 title: __asyncI18n('Plant notifications', 'subnavi.administration.system.alarms'),
            //                 contentRoute: '/Site/SiteAdministration/Alarms/:plantid'
            //             }
            //         },
            //         {
            //             path: 'Add',
            //             component: WinFormsContentScreen,
            //             data: {
            //                 title: __asyncI18n('Add notifications', 'subnavi.administration.system.add-alarm'),
            //                 contentRoute: '/Site/SiteAdministration/SiteAlarm/:plantid',
            //                 showParentInSubNavigation: true,
            //                 favouritesTitle: '[ParentPageName]'
            //             }
            //         },
            //         {
            //             path: 'CreateFromTemplate',
            //             component: WinFormsContentScreen,
            //             data: {
            //                 title: __asyncI18n(
            //                     'Create plant notification from template',
            //                     'subnavi.administration.plant.create-alarm-from-template'
            //                 ),
            //                 contentRoute: '/Site/SiteAdministration/CreateAlarmFromTemplate/:plantid',
            //                 showParentInSubNavigation: true,
            //                 favouritesTitle: '[ParentPageName]'
            //             }
            //         },
            //         {
            //             path: ':alarmnotificationsid',
            //             component: WinFormsContentScreen,
            //             data: {
            //                 title: ':alarmnotificationsid',
            //                 contentRoute: '/Site/SiteAdministration/SiteAlarm/:plantid?alarmId=:alarmnotificationsid',
            //                 showParentInSubNavigation: true,
            //                 favouritesTitle: '[ParentPageName]',
            //                 favouritesCaption: '[ParentParentPageName] / [AlarmNoteName]'
            //             }
            //         }
            //     ]
            // },
            {
                path: 'SystemNotifications',
                data: {
                    title: __asyncI18n('System Notifications', 'subnavi.administration.system.notifications'),
                    privileges: [
                        RoutePrivilegeNames.SystemAlarmNotification,
                        RoutePrivilegeNames.ReadOnlySystemAlarmNotifications
                    ],
                    testId: 'sidenavigation.system.notifications',
                    dontShowFavourites: true
                },
                children: [
                    {
                        path: '',
                        component: SystemNotificationListComponent,
                        data: {
                            title: __asyncI18n('System Notifications', 'subnavi.administration.system.notifications'),
                            testId: 'sidenavigation.system.notifications',
                            dontShowFavourites: true,
                            showParentInSubNavigation: true
                        }
                    },
                    {
                        path: 'Add',
                        component: SystemNotificationSettingsComponent,
                        data: {
                            title: __asyncI18n('Add System Notification', 'subnavi.administration.system.notifications.add'),
                            testId: 'sidenavigation.system.notifications.add',
                            dontShowFavourites: true,
                            showParentInSubNavigation: true
                        }
                    },
                    {
                        path: 'CreaateFromTemplate',
                        component: SystemNotificationCreateFromTemplateComponent,
                        data: {
                            title: __asyncI18n('Create Notification From Template', 'subnavi.administration.system.notifications.from.template'),
                            testId: 'sidenavigation.system.notifications.settings',
                            dontShowFavourites: true,
                            showParentInSubNavigation: true
                        }
                    },
                    {
                        path: ':systemnotificationid',
                        component: SystemNotificationSettingsComponent,
                        data: {
                            title: __asyncI18n('System Notifications Settings', 'subnavi.administration.system.notifications.settings'),
                            testId: 'sidenavigation.system.notifications.settings',
                            dontShowFavourites: true,
                            showParentInSubNavigation: true
                        }
                    }
                ]
            },
           
            {
                path: 'Plants',
                component: SystemPlantsComponent,
                data: {
                    title: __asyncI18n('System plants', 'subnavi.administration.system.plants'),
                    privileges: [RoutePrivilegeNames.Systems],
                    testId: 'sidenavigation.system.plants',
                    dynamicSiblings: SystemApplicationSetNaviExtension
                }
            },
            {
                path: 'ConfirmDelete',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('Confirm delete', 'subnavi.administration.system.confirmdelete'),
                    contentRoute: '/Site/SiteAdministration/ConfirmDelete/:systemid',
                    testId: 'sidenavigation.system.confirmdelete',
                    dontShowInSubNavigation: true
                }
            },
            {
                path: 'Operating',
                component: WinFormsContentScreen,
                data: {
                    title: __asyncI18n('System operating', 'subnavi.administration.system.operating'),
                    redirectTo: 'Operating/Systems/:systemid',
                    privileges: [
                        RoutePrivilegeNames.Systems,
                        RoutePrivilegeNames.SystemDashboard,
                        RoutePrivilegeNames.SystemAlarm,
                        RoutePrivilegeNames.SystemGraphic,
                        RoutePrivilegeNames.SystemGraphic,
                        RoutePrivilegeNames.SystemFileAccess,
                        RoutePrivilegeNames.SystemFileManage
                    ],
                    testId: 'sidenavigation.system.operating'
                }
            }
        ]
    }
];
